import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projectVerification: [],
  allProjectVerification: [],
  allProjectVerificationCount: []
};

export const ProjectVerificationSlice = createSlice({
  name: "projectVerification",
  initialState,
  reducers: {
    getProjectVerificationsAction: (state, action) => {
      state.allProjectVerification = action.payload;
    },
    getProjectVerificationsCountAction: (state, action) => {
      state.allProjectVerificationCount = action.payload;
    },
    getProjectVerificationAction: (state, action) => {
      state.projectVerification = action.payload;
    },
  },
});

export default ProjectVerificationSlice.reducer;

export const { getProjectVerificationsAction, getProjectVerificationsCountAction, getProjectVerificationAction } = ProjectVerificationSlice.actions;
